import React, { FC } from 'react';

interface TabItemProps {
  title: string;
}

export const TabItem: FC<TabItemProps> = ({ children, title }) => {
  return <div id={title}>{children}</div>;
};
